import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/router';
import React, { useEffect, useRef, useState } from 'react';

// import required modules
import { getAppleStoreLink, getAppLinkInBox, getMediaAppLink, isAndroid, isIOS } from '../../../../common/utils/appLinkUtil';
import { toPercentTime, toPercentTimeDesc, updateQueryStringParameter } from '../../../../common/utils/convertUtil';

export default function liveBox(props) {
  const [liveTab, setLiveTab] = useState(0);
  const hyperLink = useRef(null);
  let [maxPageCount, setMaxPageCount] = useState(0);
  let [result, setResult] = useState(props.data.contents1);

  useEffect(() => {

    if (liveTab == 0) {
      setMaxPageCount(props.data.contents1.length / 2);
      const resultList = props.data.contents1.map((item) => {
        if (item.url_link?.indexOf('/live/') > -1) {
          const channelId = item.url_link.split('/').pop().split('#')[0].split('?')[0];
          item.url_link = getAppLinkInBox(channelId, undefined, (item.url_link?.indexOf('multiaudio') > -1 ? 'multiaudio_normal' : undefined))
        }
        return item;
      });
      setResult(resultList);

    } else {

      setMaxPageCount(props.data.contents2.length / 2);
      const resultList = props.data.contents2.map((item) => {
        if (item.url_link?.indexOf('/live/') > -1) {
          const channelId = item.url_link.split('/').pop().split('#')[0].split('?')[0];
          item.url_link = getAppLinkInBox(channelId, undefined, (item.url_link?.indexOf('multiaudio') > -1 ? 'multiaudio_normal' : undefined))
        }
        return item;
      });
      setResult(resultList);
    }

  }, [liveTab])
  useEffect(() => {
    //alert('www');
    window.__SBSLogModuleDataLayer = window.__SBSLogModuleDataLayer || [];
  }, []);
  //link로그를

  const handleClick = () => {
    let moduleSubTitle;
    let contentTitle;
    let contentId;

      moduleSubTitle = '전체채널';
      contentTitle ='';
      contentId = '';

    //통계에 넙겨줄 값을정리한다,상단여역 pgmbox 프로그램 / 메뉴 / 플레이톡이 있음

    window.__SBSLogModuleDataLayer.push({
      type: 'content',
      option: {
        moduleId: '', //모듈 아이디 없으면
        moduleTitle: '실시간라이브/24시간TV', //모듈 제목 (Require)
        moduleSubTitle: moduleSubTitle,
        moduleActive: 'C', //콘텐츠 선택 정보 Click: C, Hover: H
        moduleSeq: props.loc_idx, //페이지에서 해당 모듈의 위치
        moduleItemSeq: '', //모듈 내에서 콘텐츠의 위치
        programId: '', //프로그램의 아이디 (추가)
        programTitle: '', //프로그램의 제목 (추가)
        contentId: contentId,//식별자
        contentTitle: contentTitle, //콘텐츠의 제목  (Require)
        contentType: 'L', //콘텐츠의 타입 (별도 표 참조)
      }
    });
  };


  const handleClick_custom = (a,b,c,d) => {


    //통계에 넙겨줄 값을정리한다,상단여역 pgmbox 프로그램 / 메뉴 / 플레이톡이 있음



    window.__SBSLogModuleDataLayer.push({
      type: 'click',
      option: {
        clickName: '라이브전체채널',
        clickType: 'NC',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: ''
      }
    });

  };




  const onClickLink = (link,info,index) => {
//    alert('www== ' + index);

    let moduleSubTitle;
    let contentTitle;
    let contentId;
    let conver_current_s = (parseInt(index) + 1);
    //alert('conver_current_s== ' + conver_current_s);
    let conver_current_s2 = (parseInt(props.loc_idx) + 1);
    //alert('배치에대한컴== ' + conver_current_s2);

    if(liveTab  == 0){
      moduleSubTitle = '실시간라이브';
      contentTitle = info.title;
      contentId = info.channelid;
    }else if(liveTab  == 1){
      moduleSubTitle = '24t시간TV';
      contentTitle = info.title;
      contentId = info.channelid;
    }

    window.__SBSLogModuleDataLayer.push({
      type: 'content',
      option: {
        moduleId: '', //모듈 아이디 없으면
        moduleTitle: '실시간라이브/24시간TV', //모듈 제목 (Require)
        moduleSubTitle: moduleSubTitle,
        moduleActive: 'C', //콘텐츠 선택 정보 Click: C, Hover: H
        moduleSeq: conver_current_s2, //페이지에서 해당 모듈의 위치
        moduleItemSeq: conver_current_s, //모듈 내에서 콘텐츠의 위치
        programId: '', //프로그램의 아이디 (추가)
        programTitle: 'contentTitle', //프로그램의 제목 (추가)
        contentId: '라이브',//식별자
        contentTitle: contentTitle, //콘텐츠의 제목  (Require)
        contentType: 'L', //콘텐츠의 타입 (별도 표 참조)
      }
    });



    if (isIOS()) {
      // ios 일때

      if (link.indexOf('mode=multiaudio') > -1) {
        alert('멀티 오디오 기능은 안드로이드 기기에서만 지원합니다');
        return;
      }

      let checkAppInstall, clickTimer;
      const eventclearTimers = function () {
        clearInterval(checkAppInstall);
        clearTimeout(clickTimer);
      };

      const intervalCheckHidden = function () {
        if (document.webkitHidden || document.hidden) {
          //console.log('clear - app installed.');
          eventclearTimers();
        }
      };

      checkAppInstall = setInterval(intervalCheckHidden, 200);

      clickTimer = setTimeout(function () {
        if (link.indexOf('sbsplayer://') === 0) {
          window.location = getAppleStoreLink();
        }
      }, 3000);

      window.location = `${link}`;

    } else if (isAndroid()) { // android 일때

      let checkAppInstall, clickTimer;
      const eventclearTimers = function () {
        clearInterval(checkAppInstall);
        clearTimeout(clickTimer);
      };

      const intervalCheckHidden = function () {
        if (document.webkitHidden || document.hidden) {
          //console.log('clear - app installed.');
          eventclearTimers();
        }
      };

      checkAppInstall = setInterval(intervalCheckHidden, 200);

      clickTimer = setTimeout(function () {
        if (link.indexOf('intent://') === 0) {
          window.location = getAppleStoreLink(); //플레이스토어
        }
      }, 3000);

      window.location = `${link}`;
    } else { // android 일때
      window.location = `${link}`;
    }
  };

  return (
    <>
      {/* <!-- 화이트 배경 -->*/}
      <div className="mainContents-typeWhite">
        {/* <!-- 실시간라이브, 24시간TV 탭 영역 -->*/}
        <div className="contentsBlock_w">
          <div className="moduleTitleline_w">
            <div className="moduleTitleline_linkType">
              <h2 className="moduleTitleline-Title"><a href="#none" onClick={() => setLiveTab(0)} className={`moduleTitleline-link${liveTab == 0 ? ' current' : ''}`}>실시간 라이브</a></h2>
              <span className="moduleTitleline-Dot"></span>
              <h2 className="moduleTitleline-Title"><a href="#none" onClick={() => setLiveTab(1)} className={`moduleTitleline-link${liveTab == 1 ? ' current' : ''}`}>24시간 TV</a></h2>
            </div>
            <a href={props.data.alllink_url} onClick={(e) => handleClick_custom(e, '','0','all')} className="moduleTitleline-linkMore" style={{ visibility: (props.data.alllink_yn == 'Y' && props.data.alllink_url != '' && props.data.alllink_url != null) ? 'visible' : 'hidden' }}>{props.data.alllink_title}</a>
          </div>

          <div className={"listModule_w_live live" + props.loc_idx}>
            <div className="listModuleSlider listScrollSlider">{/* <!-- mySwiper 클래스 추가시 동작 -->*/}
              {/* <!-- 리스트 -->*/}
              <div className="SliderContent swiper-wrapper">
                {
                  result.map((item, index) => {
                    let progressPercent = (item.starttime && item.endtime) ? toPercentTime(item.starttime, item.endtime) : null;
                    progressPercent = (progressPercent > 100 || progressPercent < 0) ? null : progressPercent;
                    const progressDesc = (progressPercent) ? toPercentTimeDesc(item.starttime, item.endtime, progressPercent) : '';

                    const handleOpenPopup = () => {
                      //  485 * 928
                      const popup = window.open(item.talk_link, '타이틀명을 입력하시오', 'top=0, left=0, width=485, height=928, status=no, menubar=no, toolbar=no, resizable=no');
                    }

                    return (
                      <div className="listModuleItem swiper-slide">
                        <div className="moduleBoxWrap_live">
                          <a ref={hyperLink} onClick={() => onClickLink(item.url_link,item,index)} className="mb_link">
                            <div className="mb_image_w">
                              <div className="mb_image_inner">
                                <img src={item.img_url} className="mb_image" alt={item.img_url} />
                              </div>
                              <div className="mb_progress_w">
                                <i className="hide">라이브 총시간 및 진행시간</i>
                                <span className="mb_progress" style={{ width: `${progressPercent}%` }} title={progressDesc}></span>
                              </div>
                              <div className="mb_label_w">
                                {(item.channelid === 'S17' || item.channelid === 'S18') && (item.bora_yn === 'Y') ? (
                                  <span className="mb_label_bora">보라</span>
                                ) : ''}
                              </div>
                            </div>
                            <div className="mb_info_w">
                              <span className="mbif_title">{item.title}</span>
                              <span className="mbif_subinfo">{item.sub_title}</span>
                            </div>
                          </a>
                          <div className="moduleBottomBtns">
                            <a href="#none" onClick={handleOpenPopup} className="btnType-playtalk">
                              <span className="iconSvg_playtalk"></span>
                              <strong className="btnType-title">플레이톡</strong>
                            </a>
                          </div>
                        </div>
                      </div>
                    );
                  })
                }
              </div>
            </div>
          </div>
        </div >
      </div >
    </>
  );
}